import { useCallback, useState, ChangeEvent } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setAttributes } from "../../../ducks/editFeature/editFeature";
import { useDialogReset } from "../../../hooks/useDialogs";
import { getCurrentAttributes } from "../../../ducks/editFeature/selectors";

export const useImageAttribute = (options?: Record<string, unknown>) => {
  const dispatch = useDispatch();
  const currentAttributes = useSelector(getCurrentAttributes);
  const [imageUrl, setImageUrl] = useState("");
  const name = options && options.name;
  const cancelDialog = useDialogReset();

  const changeImageUrl = useCallback(
    ({ target }: ChangeEvent<HTMLInputElement>) => {
      setImageUrl(target.value);
    },
    [setImageUrl],
  );

  const addImageUrl = useCallback(() => {
    const updateAttribute = currentAttributes.map(attribute => {
      if (attribute.name === name) {
        return { ...attribute, value: attribute.value ? `${attribute.value};${imageUrl}` : imageUrl };
      }

      return attribute;
    });

    dispatch(setAttributes(updateAttribute));
    cancelDialog();
  }, [name, imageUrl, dispatch, cancelDialog, currentAttributes]);

  return { imageUrl, changeImageUrl, addImageUrl };
};
